import { http } from "@/lib/http";

import type {
  AclAttachRequest,
  AclRule,
  AclRulesReplaceRequest,
  NetworkAcl,
  NetworkAclCreateRequest,
  NetworkAclUpdateRequest,
} from "./types";

export async function listAcls(): Promise<NetworkAcl[]> {
  const { data } = await http.get<NetworkAcl[]>("/network/acls");
  return data;
}

export async function getAcl(aclId: string): Promise<NetworkAcl> {
  const { data } = await http.get<NetworkAcl>(`/network/acls/${aclId}`);
  return data;
}

export async function createAcl(
  payload: NetworkAclCreateRequest,
): Promise<NetworkAcl> {
  const { data } = await http.post<NetworkAcl>("/network/acls", payload);
  return data;
}

export async function updateAcl(
  aclId: string,
  payload: NetworkAclUpdateRequest,
): Promise<NetworkAcl> {
  const { data } = await http.put<NetworkAcl>(
    `/network/acls/${aclId}`,
    payload,
  );
  return data;
}

export async function deleteAcl(aclId: string): Promise<void> {
  await http.delete(`/network/acls/${aclId}`);
}

/** Replace the ordered rule list in one call — the server rebuilds the
 *  order, so the array position IS the evaluation order. */
export async function replaceAclRules(
  aclId: string,
  rules: AclRule[],
): Promise<NetworkAcl> {
  const body: AclRulesReplaceRequest = { rules };
  const { data } = await http.put<NetworkAcl>(
    `/network/acls/${aclId}/rules`,
    body,
  );
  return data;
}

export async function attachAcl(
  aclId: string,
  routerId: string,
): Promise<NetworkAcl> {
  const body: AclAttachRequest = { router_id: routerId };
  const { data } = await http.post<NetworkAcl>(
    `/network/acls/${aclId}/attach`,
    body,
  );
  return data;
}

export async function detachAcl(aclId: string): Promise<NetworkAcl> {
  const { data } = await http.post<NetworkAcl>(`/network/acls/${aclId}/detach`);
  return data;
}
